"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/09/04
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHUNK_SIZE = void 0;
exports.getValidationConfig = getValidationConfig;
const metadata_1 = require("./metadata");
const CHUNK_SIZE = 100 * 1024 * 1024; // 100MB
exports.CHUNK_SIZE = CHUNK_SIZE;
function getValidationConfig() {
    const ALLOWED_GROUPS = [metadata_1.IMAGES_INFO, metadata_1.DOCUMENTS_INFO];
    return {
        maxFileSize: 50 * 1024 * 1024, // 50MB
        allowedMimeTypes: ALLOWED_GROUPS.flatMap((group) => group.MIME_TYPES),
        allowedExtensions: ALLOWED_GROUPS.flatMap((group) => group.EXTENSIONS),
        maxFilenameLength: 255,
    };
}
//# sourceMappingURL=config.js.map